// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__2zmNU","imageUploader":"EGiftCard_imageUploader__23tjL"};